import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMenuIconSecondary from './svgs/MenuIconSecondary.js';
import SvgMenuIcon from './svgs/MenuIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var menuIcon = (props => useIcon(SvgMenuIcon, SvgMenuIconSecondary, props));

export { menuIcon as default };
